import homeActions from "./store/home-actions";
import homeState from "./store/home-state";
import homeMutations from "./store/home-mutations";

/* This is the syntax for creating a Vuex module of authentication proccess. */
const home = {
  namespaced: true,
  state: homeState,
  actions: homeActions,
  mutations: homeMutations,
};

export { home };
